
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-gray-900 overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(17, 24, 39, 0.8), rgba(17, 24, 39, 0.8)), url('https://public.readdy.ai/ai/img_res/192203fea77c850037e54c0936949f83.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Professional
            <span className="text-yellow-400 block">Electrical Solutions</span>
            for Your Home
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl leading-relaxed">
            Expert residential electrical services combining quality craftsmanship with innovative solutions. 
            Licensed, insured, and committed to powering your home safely.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
            <Button size="lg" className="w-full sm:w-auto px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
              <i className="ri-calendar-line text-xl mr-3"></i>
              Schedule Service
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 border-2 hover:border-yellow-300">
              <i className="ri-calculator-line text-xl mr-3"></i>
              Get Free Quote
            </Button>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-32 h-32 bg-yellow-400/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 left-20 w-48 h-48 bg-yellow-400/5 rounded-full blur-2xl"></div>
    </section>
  );
}